import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { logo } from '../../assets/svg/logos';
import banner from '../../assets/svg/not-found.svg';

function NotFoundPage() {
    const { t } = useTranslation();
    return (
        <main className="not-found">
            <header className="position-absolute-top-0 z-index-2">
                <nav className="d-flex justify-content-between align-items-center">
                    <div className="col-lg-5 col-xl-4 text-lg-center px-0">
                        <Link className="d-inline-block p-3 p-sm-5" to="/" aria-label="Doyo">
                            <img src={logo} height="42px" alt="Logo" />
                        </Link>
                    </div>
                </nav>
            </header>
            <div
                className="jumbotron jumbotron-fluid d-flex flex-column justify-content-center align-items-center mb-0 p-0"
                style={{ backgroundImage: `url(${banner})` }}
            >
                <div className="mt--5 d-flex flex-column justify-content-center align-items-center position-relative text-center z-index-2">
                    <h1 className="text-secondary rounded" style={{ background: '#f0f1f3' }}>
                        {t('not_found.title')}
                    </h1>
                    <p className="rounded" style={{ background: '#f0f1f3' }}>
                        {t('not_found.subtitle')}
                    </p>
                    <Link to="/" aria-label="Doyo">
                        <Button variant="primary">{t('not_found.button')}</Button>
                    </Link>
                </div>
            </div>
        </main>
    );
}

export default NotFoundPage;
export { NotFoundPage };
